import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const ResumeSequenceInstanceWrapper = styled.div`
  width: 352px;
  font-size: 14px;
  padding: 16px;
  overflow: hidden;

  .base-button {
    display: flex;
    align-items: center;
    text-transform: unset !important;
    height: 32px;
    font-size: 14px;
    border-radius: 999px;
    padding-inline: 4px 7px;
    font-weight: 500;
    background-color: ${colors.primaryLight};
    cursor: pointer;
  }

  .div-add-staretgy-plus {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${colors.primary};
    margin-right: 8px;
  }

  .strategy-to-resume {
    border-left: 4px solid ${colors.grey4};
    border-radius: 4px;
    padding-left: 6px;
    margin-block: 12px;
  }
`;
